/** Publish confirmation dialog with required-fields checklist. */
import { Check, AlertCircle } from 'lucide-react';

const REQUIRED_FIELDS = [
    { key: 'title', label: 'Title (EN or VI)', check: (d) => d.title_en || d.title_vi },
    { key: 'overview', label: 'Overview (EN or VI)', check: (d) => d.overview_en || d.overview_vi },
    { key: 'capabilities', label: 'Capabilities (EN or VI)', check: (d) => d.capabilities_en || d.capabilities_vi },
    { key: 'client_fit', label: 'Client Fit → Agency Types', check: (d) => d.client_fit?.agency_types?.length > 0 },
    { key: 'category', label: 'Category', check: (d) => d.category_id },
];

export default function PublishDialog({ data, onPublish, onCancel }) {
    const checks = REQUIRED_FIELDS.map(f => ({
        ...f,
        pass: f.check(data),
    }));
    const allPass = checks.every(c => c.pass);

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={onCancel}>
            <div className="bg-slate-800 rounded-xl border border-slate-600 p-6 w-full max-w-md shadow-2xl" onClick={e => e.stopPropagation()}>
                <h2 className="text-lg font-semibold text-white mb-4">Publish Entry</h2>
                <p className="text-sm text-slate-400 mb-4">Review the required fields before publishing:</p>

                <ul className="space-y-2 mb-6">
                    {checks.map(c => (
                        <li key={c.key} className={`flex items-center gap-2 text-sm ${c.pass ? 'text-green-400' : 'text-orange-400'}`}>
                            {c.pass ? <Check size={16} /> : <AlertCircle size={16} />}
                            {c.label}
                        </li>
                    ))}
                </ul>

                <div className="flex justify-end gap-3">
                    <button
                        type="button"
                        onClick={onCancel}
                        className="px-4 py-2 rounded-lg bg-slate-700 hover:bg-slate-600 text-sm text-slate-200"
                    >Cancel</button>
                    <button
                        type="button"
                        disabled={!allPass}
                        onClick={onPublish}
                        className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${allPass ? 'bg-green-600 hover:bg-green-500 text-white' : 'bg-slate-600 text-slate-400 cursor-not-allowed'}`}
                    >Publish</button>
                </div>
            </div>
        </div>
    );
}